export default __webpack_public_path__ + "static/media/likeSelected.840f528f.svg";